/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";

function ItemSelectRewarduser(props) {
  const [showSuggestions, setShowSuggestions] = useState(false); // State to control suggestion visibility
  const [error, setError] = useState(null);

  const [searchText, setSearchText] = useState("");

  // Filter the full list by name or email, then cap what is rendered.
  const query = searchText.trim().toLowerCase();
  const filteredUsers = props.RUsersData.filter(
    (user) =>
      !query ||
      (user.display_name || "").toLowerCase().includes(query) ||
      (user.email_id || "").toLowerCase().includes(query)
  );

  useEffect(() => {
    if (!props.activeUser.email_id) {
      setSearchText("");
    } else {
      setSearchText(props.activeUser.email_id);
    }
  }, [props.activeUser]);

  const handleChangeTitle = async (evt) => {
    setSearchText(evt.target.value);
    setError(null);
    setShowSuggestions(true);
  };

  return (
    <div>
      <input
        className={"form-control"}
        value={searchText}
        placeholder="Search user by name.."
        onChange={handleChangeTitle}
        onFocus={() => {
          props.setActiveUser({});
          setShowSuggestions(true);
        }}
      />
      {showSuggestions && (
        <div className="suggestions">
          {filteredUsers.slice(0, 10).map((user) => (
            <div
              className="suggestion"
              key={user.id}
              onClick={() => {
                props.setActiveUser(user);
                setShowSuggestions(false);
              }}
            >
              {user.display_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ItemSelectRewarduser;
